import React from 'react';
import { Button } from '@mui/material';
import { Send as SendIcon } from '@mui/icons-material';
import { useRequestContext } from './Requests';

/**
 * RequestButton - Bouton pour créer une demande depuis un template
 * 
 * Ce composant peut être utilisé dans les templates d'items pour permettre
 * aux utilisateurs de créer des demandes basées sur l'item affiché.
 */
export const RequestButton = ({
    item,
    text = "Créer une demande",
    variant = "contained",
    color = "primary",
    size = "medium",
    disabled = false,
    startIcon = <SendIcon />,
    sx = {},
    onClick = null,
    ...props
}) => {
    const { 
        createRequest, 
        userInfoValid, 
        isCreatingRequest 
    } = useRequestContext();

    const handleClick = async (e) => {
        e.preventDefault();
        e.stopPropagation();

        if (!userInfoValid) {
            alert('Veuillez remplir vos coordonnées avant de créer une demande.');
            return;
        }

        if (!item) {
            alert('Aucun élément sélectionné pour créer une demande.');
            return;
        }

        try {
            // Callback personnalisé si fourni
            if (onClick) {
                await onClick(item);
            }
            
            // Créer la demande
            await createRequest(item);
            
        } catch (error) {
            console.error('[RequestButton] Erreur:', error);
            alert('Erreur lors de la création de la demande.');
        }
    };

    return (
        <Button
            variant={variant}
            color={color}
            size={size}
            disabled={disabled || isCreatingRequest || !userInfoValid}
            startIcon={isCreatingRequest ? null : startIcon}
            onClick={handleClick}
            sx={{
                ...sx,
                opacity: !userInfoValid ? 0.5 : 1
            }}
            {...props}
        >
            {isCreatingRequest ? 'Création...' : text}
        </Button>
    );
};

export default RequestButton;